// extracted by mini-css-extract-plugin
export default {"historyPreview":"SubAccountHistoryMessagesPreview_historyPreview__BtMtl"};